<div class="tree default" *ngIf="advisories?.length">
  <div class="items">
    <advisories-tree-advisory [advisory]="advisory" [active]="true" *ngFor="let advisory of advisories"></advisories-tree-advisory>
  </div>
</div>
